import { INSCRIPCION_PASO_TRES_AL_DOS_URL, INSCRIPCION_PASO_TRES_AL_CUATRO_URL } from '../config';
import axios from 'axios';

export function postPasoTresAlDos(params) {
    const result = axios.post(INSCRIPCION_PASO_TRES_AL_DOS_URL, params);
    return result;
};

export function postPasoTresAlCuatro(params) {
    const result = axios.post(INSCRIPCION_PASO_TRES_AL_CUATRO_URL, params);
    return result;
}